import React, { useContext } from 'react';
import { Row, Col, Divider, Image } from 'antd';
import lapis from '../../assets/icons/lapisEditar.svg';
import lapisCinza from '../../assets/icons/lapisEditarCinza.svg';
import * as S from './styles';
import { EditorContext } from '../../pages/Atendimento/EditorContext/editorContext';

export function TitleSections({
  title,
  subTitle,
  isHistory = false,
  withButton,
  buttonText,
  setReadOnly,
  readOnly,
  backgroundColorButton,
}) {
  const { lockButton, setLockButton } = useContext(EditorContext);

  return (
    <Col justify="center" md={24} lg={24} xs={24}>
      <Row justify="space-between" align="top">
        <S.TextSectiosTabs title={title ? 1 : 0}>
          {title || ''}
        </S.TextSectiosTabs>
        {isHistory && <ChipReanalise />}
        {withButton && readOnly && (
          <ButtonEdit
            buttonText={buttonText}
            setReadOnly={setReadOnly}
            backgroundColorButton={backgroundColorButton}
            lockButton={lockButton}
            setLockButton={setLockButton}
          />
        )}
      </Row>
      <Row justify="space-between" align="top">
        <S.TextSectiosTabs>{subTitle || ''}</S.TextSectiosTabs>
      </Row>
      <Divider
        style={{
          margin: '6px 0 0 0',
          border: '1px solid #BDBDBD',
        }}
      />
    </Col>
  );
}
function ButtonEdit({
  buttonText,
  setReadOnly,
  backgroundColorButton,
  lockButton,
  setLockButton
}) {
  const handleEdit = () => {
    setReadOnly(false);
    lockButton === false && setLockButton(true);
  };
  return (
    <S.ButtonStyled
      onClick={() => handleEdit()}
      backgroundColorButton={backgroundColorButton}
      lockButton={lockButton}
      disabled={lockButton}
    >
        {!lockButton ? (
          <Image src={lapis} preview={false} width={16} />
        ) : (
          <Image src={lapisCinza} preview={false} width={16} />
        )}
      {buttonText || 'Editar'}
    </S.ButtonStyled>
  );
}

function ChipReanalise() {
  const textTitle = `Verifique as observações
   da solicitação anterior,
    logo abaixo.`;
  return (
    <S.TooltipStyle
      color="#0D3549"
      placement="topRight"
      title={textTitle}
      arrowPointAtCenter
    >
      Reanálise
    </S.TooltipStyle>
  );
}
